import * as React from 'react';
import styled from 'styled-components';
import cl from 'classnames';

import { colorsV2 } from '../../colors-v2';

const Container = styled.div`
  padding: 12px 32px 24px;
  background-color: ${colorsV2.white100};
  border-radius: 0px 0px 16px 16px;

  &.with-divider {
    padding: 20px 32px 24px;
    border-top: 1px solid #f0f0f2;
  }
`;

interface ModalFooterProps {
  divider?: boolean;
  footerContent?: React.ReactNode;
  className?: string;
}

export const ModalFooter = (props: ModalFooterProps) => {
  const { divider = false, footerContent, className } = props;

  return (
    <Container className={cl('modal-footer', { 'with-divider': divider }, className)}>
      {footerContent}
    </Container>
  );
};
